module.exports = __webpack_public_path__ + "static/media/Item_Weapon_AK47_C.c0e528c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_AK47_C.png
// module id = 383
// module chunks = 0